import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import gsap from "gsap"
import { useStore } from "@state/store"

const ImageOverlay = ({ selectedUnit, controlIndex = null }) => {
  const imageRef = useRef()
  const imageOverlay = useStore((s) => s.imageOverlay)

  useEffect(() => {
    gsap.to(imageRef.current, {
      autoAlpha: imageOverlay ? 1 : 0,
      duration: 0.3,
    })
  }, [imageOverlay])

  let imgSrc

  if (selectedUnit) {
    imgSrc = selectedUnit[0]?.floorplan
  }

  return (
    <Wrapper ref={imageRef} className="imageOverlay">
      {selectedUnit && (
        <img src="/assets/imgs/floorplan.png" alt={"floorplan"} /> // Hardcoded for now
      )}
    </Wrapper>
  )
}

export default ImageOverlay

const Wrapper = styled.div`
  padding: 3rem;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: var(--primary);
  display: flex;

  img {
    margin: auto;

    width: 90%;
    height: 100%;
    object-fit: contain;
  }
`
